module.exports = __webpack_public_path__ + "Frame6-ab8cd5ad.webp";